// extracted by mini-css-extract-plugin
module.exports = {"email":"ConfirmEmailDialog_email__2fjZC","icon":"ConfirmEmailDialog_icon__2H0i_"};